import { useEffect, useMemo, useRef } from "react";
import { useSite } from "@/context/SiteContext";

const WIDGET_HTML = `
<style>
  .alaric-widget, .alaric-widget body { font-family: 'Plus Jakarta Sans', system-ui, sans-serif; }
  .alaric-widget .containerrr { width: 100% !important; margin: 0 !important; }
  .alaric-widget .calcal, .alaric-widget .calcal form, .alaric-widget .bx1 { background: transparent !important; box-shadow: none !important; border: 0 !important; }
  .alaric-widget .bx1 { display: flex; align-items: stretch; gap: 4px; }
  .alaric-widget .box { flex: 1; padding: 6px 14px; position: relative; }
  .alaric-widget .box p { margin: 0; }
  .alaric-widget .mb-8 { margin-bottom: 3px !important; font-size: 9px; text-transform: uppercase; letter-spacing: 0.16em; color: rgba(255,255,255,0.65); font-family: 'JetBrains Mono', monospace; }
  .alaric-widget .fs-15 { font-size: 13px; color: #fff; white-space: nowrap; }
  .alaric-widget .alrc_checkin_txt, .alaric-widget .alrc_checkout_txt { white-space: nowrap; }
  .alaric-widget .cursor-pointer { cursor: pointer; }
  .alaric-widget .d-flex { display: flex; align-items: center; gap: 6px; }
  .alaric-widget .alrc-icon { width: 14px; height: 14px; filter: brightness(0) invert(1); opacity: .85; }
  .alaric-widget .separated { display: none; }
  .alaric-widget .bx1 .box:nth-child(3) { display: none; }
  .alaric-widget input.promocode { border: 0; outline: 0; font-size: 13px; background: transparent; color: #fff; width: 110px; font-family: inherit; }
  .alaric-widget input[type=submit] { background: #1A6289 !important; border-color: #1A6289 !important; color: #F7F5F0; border-radius: 999px; padding: 11px 22px; font-weight: 600; cursor: pointer; width: 100%; font-size: 13px; font-family: inherit; transition: background .2s; }
  .alaric-widget input[type=submit]:hover { background: #144D6C !important; }
  .alaric-widget .m-calcal { display: none !important; }
  .alaric-widget .modal-guest { position: absolute; top: 100%; left: 0; z-index: 40; background: #F7F5F0; color: #0E1B2E; border-radius: 14px; padding: 14px 16px; min-width: 230px; box-shadow: 0 18px 50px rgba(0,0,0,0.3); display: none; }
  .alaric-widget .modal-guest p { color: #0E1B2E; }
  .alaric-widget .spinner { border: 1px solid rgba(14,27,46,0.2); border-radius: 999px; overflow: hidden; }
  .alaric-widget .sub_min, .alaric-widget .sub_add { padding: 4px 12px; cursor: pointer; color: #1A6289; font-weight: 600; user-select: none; }
  .alaric-widget .spinner_val { padding: 4px 8px; min-width: 20px; text-align: center; }
  .date-picker-wrapper { font-family: 'Plus Jakarta Sans', sans-serif; z-index: 9999; background: #F7F5F0 !important; border-radius: 14px; box-shadow: 0 30px 80px rgba(14,27,46,0.35); border: 1px solid rgba(14,27,46,0.08); padding: 6px !important; width: auto !important; }
  .date-picker-wrapper .drp_top-bar { display: none !important; }
  .date-picker-wrapper .month-wrapper { display: flex !important; gap: 0 !important; width: auto !important; border-radius: 12px; overflow: hidden; }
  .date-picker-wrapper .month-wrapper table { width: 240px !important; flex-shrink: 0; }
  .date-picker-wrapper .month-wrapper table + table { border-left: 1px solid rgba(14,27,46,0.08); }
  .date-picker-wrapper .month-wrapper table thead th { font-size: 10px !important; }
  .date-picker-wrapper .month-wrapper table .caption { font-size: 11px !important; }
  .date-picker-wrapper .month-wrapper table td { padding: 1px !important; }
  .date-picker-wrapper .month-wrapper table td > div.day { font-size: 12px !important; padding: 5px 0 !important; height: auto !important; position: relative; }
  .date-picker-wrapper .month-wrapper table .day.real-today { background: rgba(26,98,137,0.12) !important; }
  .date-picker-wrapper.no-topbar .gap { display: none !important; }
  .date-picker-wrapper .month-wrapper table .day.checked { background-color: rgba(26,98,137,0.15) !important; }
  .date-picker-wrapper .first-date-selected, .date-picker-wrapper .last-date-selected { background-color: #1A6289 !important; color: #fff !important; }
  .alaric-widget .alrc-year { font-size: 9px; opacity: 0.6; display: block; line-height: 1; margin-top: 1px; }
  @media (max-width: 640px) {
    .date-picker-wrapper { max-width: calc(100vw - 24px); }
    .date-picker-wrapper .month-wrapper { flex-direction: column; gap: 8px; max-height: 60vh; overflow-y: auto; }
  }
  @media (max-width: 640px) {
    .alaric-widget .calcal, .alaric-widget .calcal form { display: block !important; }
    .alaric-widget .bx1 { display: flex !important; flex-wrap: wrap; }
    .alaric-widget .bx1 .box { display: block !important; flex: 1 1 100%; padding: 6px 10px; }
    .alaric-widget .bx1 .box:nth-child(3) { display: none !important; }
  }
</style>
<div class="containerrr calcal">
  <form action="https://booking.armellabali.com/rates/index" method="post" target="_blank">
    <input type="hidden" name="BookingForm[hotel]" value="MADN">
    <input type="hidden" name="BookingForm[utm_source]" value="">
    <input type="hidden" name="BookingForm[utm_source_session_id]" value="">
    <input type="hidden" name="BookingForm[checkin]" value="">
    <input type="hidden" name="BookingForm[checkout]" value="">
    <input type="hidden" name="BookingForm[adults]" value="">
    <input type="hidden" name="BookingForm[uid]" value="">
    <div class="bx1">
      <div class="box alrc_checkin_checkout">
        <p class="mb-8">Checkin - Checkout</p>
        <p class="fs-15 cursor-pointer">
          <span class="d-flex">
            <object class="alrc-icon" data="https://static.alaric.id/widget2/calendar-outline.svg" width="20" height="20"> </object>
            <span class="alrc_checkin_txt">—</span> &nbsp;-&nbsp; <span class="alrc_checkout_txt">—</span> <span class="dropdown" />
          </span>
        </p>
        <span class="separated" />
      </div>
      <div class="box">
        <p class="mb-8">Guests</p>
        <p class="fs-15 cursor-pointer sh-modal-guest">
          <span class="d-flex">
            <object class="alrc-icon" data="https://static.alaric.id/widget2/people-outline.svg" width="20" height="20"> </object>
            <span class="alrc_val_adult">2</span> &nbsp; Adults
            <span class="dropdown" />
          </span>
        </p>
        <span class="separated"></span>
        <div class="modal-guest">
          <div class="d-flex mb-8">
            <div class="flex-fill">
              <p class="fs-14"><strong>Adult(s)</strong></p>
              <p class="fs-12">Ages 18 or above</p>
            </div>
            <div class="flex-fill">
              <div class="d-flex spinner">
                <div class="sub_min alrc_min_adult">-</div>
                <div class="spinner_val alrc_val_adult">2</div>
                <div class="sub_add alrc_add_adult">+</div>
              </div>
            </div>
          </div>
          <div class="child-options">
            <p class="color-grey">Information of your children's age will allow us to help you find the best room types suited to your needs.</p>
            <div class="child-options-data"></div>
          </div>
        </div>
      </div>
      <div class="box">
        <p class="mb-8">Promo code</p>
        <p class="fs-15 cursor-pointer">
          <span class="d-flex">
            <object class="alrc-icon" data="https://static.alaric.id/widget2/pricetags-outline.svg" width="18" height="18" style="margin-top: 0px;"> </object>
            <input type="text" class="promocode" name="BookingForm[offer_code]" placeholder="Enter promo code" />
          </span>
        </p>
        <span class="separated"></span>
      </div>
      <div class="box flex-grow-1">
        <input class="fs-15x" type="submit" value="Check Availability" />
      </div>
    </div>
  </form>
</div>
<div class="m-calcal show-for-small-only">
  <div class="floating-btn"><button class="btn-bottom alrc-book-mobile">Book Now</button></div>
  <div class="modal-book-alrc">
    <div class="overlay-content">
      <div class="content-modal">
        <form action="https://booking.armellabali.com/rates/index" method="post" target="_BLANK">
          <input type="hidden" name="BookingForm[hotel]" id="hotel" value="MADN">
          <input type="hidden" name="BookingForm[utm_source]" value="">
          <input type="hidden" name="BookingForm[utm_source_session_id]" value="">
          <input type="hidden" name="BookingForm[checkin]" value="">
          <input type="hidden" name="BookingForm[checkout]" value="">
          <input type="hidden" name="BookingForm[adults]" value="">
          <input type="hidden" name="BookingForm[uid]" value="">
          <div class="p-20">
            <div class="head-modal"><h4>Stay Date</h4><a href="#" class="btn-close-modal alrc-close-book-mobile">✖</a></div>
            <div class="box-border">
              <p class="fs-14 mb-10 mt-0"><strong>Checkin - Checkout</strong></p>
              <div class="d-flex justify-content-between">
                <div class="fs-13">Date</div>
                <div class="fs-13 alrc_checkin_checkout_mobile"><strong><span class="alrc_checkin_txt">—</span> - <span class="alrc_checkout_txt">—</span></strong></div>
              </div>
              <div class="m-calcal-mobile" style="width:100%;"></div>
            </div>
            <div class="box-border">
              <p class="fs-14 mb-10 mt-0"><strong>Guest</strong></p>
              <div class="d-flex justify-content-between">
                <div class="fs-13"><p class="mb-5 mt-0">Adult</p><p class="mt-0 fs-12 color-secondary">Ages 18 or above</p></div>
                <div class="flex-fill">
                  <div class="d-flex spinner">
                    <div class="sub_min alrc_min_adult">-</div>
                    <div class="spinner_val alrc_val_adult">2</div>
                    <div class="sub_add alrc_add_adult">+</div>
                  </div>
                </div>
              </div>
              <div class="child-options-data"></div>
            </div>
            <div class="box-border">
              <p class="fs-14 mb-10 mt-0"><strong>Promocode</strong></p>
              <div class="d-flex justify-content-between">
                <input type="text" class="promocode" placeholder="Enter promo code" name="BookingForm[offer_code]" />
              </div>
            </div>
            <button type="submit" class="btn-bottom">Check Availability</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
`;

const INIT_JS = `
(function () {
  'use strict';
  var dataPrice = null
  function formatDate(date) {
    var d = new Date(date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
  function formatDateDmy(date) {
    var d = new Date(date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('-');
  }
  function getValueRoomPrice(timestamp) {
    return ''
  }
  function getDateFormat(date) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var dayName = days[date.getDay()];
    var dayMonth = months[date.getMonth()];
    return dayName + ', ' + dayMonth + ' ' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  }
  function getYear(date) { return date.getFullYear() }
  var init = function () {
    var qty_adult = 2
    var today = new Date()
    var tommorrow = new Date(today.getTime() + 86400000);
    $('.alrc_checkin_txt').html(getDateFormat(today) + '<span class="alrc-year"> ' + getYear(today) + '</span>')
    $('.alrc_checkout_txt').html(getDateFormat(tommorrow) + '<span class="alrc-year"> ' + getYear(tommorrow) + '</span>')
    $("input[name='BookingForm[checkin]']").val(formatDateDmy(today));
    $("input[name='BookingForm[checkout]']").val(formatDateDmy(tommorrow));
    $("input[name='BookingForm[adults]']").val(qty_adult);
    $.ajax({
      url: window.location.origin + '/api/alaric/calendar',
      type: 'GET',
      success: function (data) { dataPrice = data }
    });
    $(document).click(function (e) {
      if ($(e.target).parents(".box").length === 0) { $('.modal-guest').hide(); }
    });
    $('.sh-modal-guest').on("click", function (e) {
      $('.modal-guest').toggle();
      e.stopPropagation();
    });
    $('.alrc_add_adult').on("click", function (e) {
      qty_adult += 1
      $('.alrc_val_adult').html(qty_adult)
      $("input[name='BookingForm[adults]']").val(qty_adult);
    });
    $('.alrc_min_adult').on("click", function (e) {
      if (qty_adult > 1) { qty_adult -= 1; $('.alrc_val_adult').html(qty_adult); }
    });
    $('.alrc_checkin_checkout').dateRangePicker({
      separator: ' to ',
      autoClose: true,
      stickyMonths: true,
      selectForward: true,
      startDate: formatDate(new Date()),
      customArrowPrevSymbol: '<span class="alrc-arrow-prev"></span>',
      customArrowNextSymbol: '<span class="alrc-arrow-next"></span>',
      setValue: function (s, s1, s2) {
        $('.alrc_checkin_txt').html(getDateFormat(new Date(s1)) + '<span class="alrc-year"> ' + getYear(new Date(s1)) + '</span>')
        $('.alrc_checkout_txt').html(getDateFormat(new Date(s2)) + '<span class="alrc-year"> ' + getYear(new Date(s2)) + '</span>')
        $("input[name='BookingForm[checkin]']").val(formatDateDmy(new Date(s1)));
        $("input[name='BookingForm[checkout]']").val(formatDateDmy(new Date(s2)));
      },
      hoveringTooltip: function (days) {
        if (days >= 2) { return days - 1 + ' night' + ((days > 2) ? 's' : ''); }
        return ''
      }
    }).bind('datepicker-opened', function (v) {
      var $this = $('.date-picker-wrapper')
      $this.find("td > div.day").each(function () {
        var time = $(this).attr('time')
        if (time) { $(this).attr('data-custom', getValueRoomPrice(time)); }
      });
    })
    $(document).on('madn-price-ready', function () {
      var $w = $('.date-picker-wrapper')
      if (!$w.length) return
      $w.find("td > div.day").each(function () {
        var time = $(this).attr('time')
        if (time && !$(this).attr('data-custom')) { $(this).attr('data-custom', getValueRoomPrice(time)); }
      });
    });
    $(document).on("click", ".date-picker-wrapper .next, .date-picker-wrapper .prev", function () {
      var $this = $('.date-picker-wrapper')
      $this.find("td > div.day").each(function () {
        var time = $(this).attr('time')
        if (time) { $(this).attr('data-custom', getValueRoomPrice(time)); }
      });
    });
    function toISO(dmy) {
      var p = (dmy || '').split('-');
      if (p.length !== 3) { return formatDate(new Date()); }
      return p[2] + '-' + p[1] + '-' + p[0];
    }
    $('.calcal form, .m-calcal form').on('submit', function (e) {
      e.preventDefault();
      var f = $(this);
      var ci = toISO(f.find("input[name='BookingForm[checkin]']").val());
      var co = toISO(f.find("input[name='BookingForm[checkout]']").val());
      var ad = f.find("input[name='BookingForm[adults]']").val() || 2;
      var pc = f.find("input[name='BookingForm[offer_code]']").val() || '';
      window.open('https://booking.armellabali.com/en/offers?hotel=MADN&checkin=' + ci + '&checkout=' + co + '&adults=' + ad + '&children=0&children_ages=&promocode=' + encodeURIComponent(pc), '_blank');
    });
  }
  init();
}());
`;

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.body.appendChild(s);
  });

const shortPrice = (label) => {
  const m = (label || "").match(/([\d.,]+)/);
  if (!m) return "";
  const n = parseFloat(m[1].replace(/\./g, "").replace(",", "."));
  if (!n) return "";
  return n >= 1000 ? `${Math.round(n / 1000)}k` : `${Math.round(n)}`;
};

export const AlaricWidget = () => {
  const { rooms } = useSite();
  const ref = useRef(null);
  const started = useRef(false);

  const minPrice = useMemo(() => {
    const labels = (rooms || []).map((r) => r.price_label).filter(Boolean);
    if (!labels.length) return "650k";
    const short = labels.map(shortPrice).filter(Boolean);
    return short.length ? short[0] : "650k";
  }, [rooms]);

  useEffect(() => {
    window.__madnMinPrice = minPrice;
    if (window.jQuery) window.jQuery(document).trigger("madn-price-ready");
  }, [minPrice]);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (ref.current) ref.current.innerHTML = WIDGET_HTML;
    [
      "https://static.alaric.id/widget2/daterangepicker.min.css",
      "https://static.alaric.id/widget2/style.widget.calendar.css",
    ].forEach((href) => {
      if (!document.head.querySelector(`link[href="${href}"]`)) {
        const l = document.createElement("link");
        l.rel = "stylesheet";
        l.href = href;
        document.head.appendChild(l);
      }
    });
    (async () => {
      if (!window.jQuery) await loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/1.12.4/jquery.min.js");
      if (!window.moment) await loadScript("https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.16.0/moment.min.js");
      await loadScript("https://static.alaric.id/widget2/jquery.daterangepicker.js");
      await loadScript("https://static.alaric.id/widget2/app.alaric.booking.js?v=1.2");
      // eslint-disable-next-line no-new-func
      new Function(INIT_JS)();
    })().catch(() => {});
  }, []);

  return <div ref={ref} className="alaric-widget" data-testid="alaric-widget" />;
};
